export const getDocuments = state => state.documents;



// WEBPACK FOOTER //
// ./src/store/modules/document/getters.js